<template>
  <!-- style="overflow:hidden;overflow-x:auto;" -->
  <div id="CardHoddy" style="overflow:hidden;">
    <shop-header ref="shop_header" id="Header"></shop-header>
    <div id="Container">
      <!-- 菜单折叠 -->
      <aside-swith v-if="menuCanOpen" :path="path" id="Aside"></aside-swith>
      <seller-aside v-else :path="path" id="Aside"></seller-aside>
      <div id="Main" ref="MainBox" style="overflow-y:auto;" :class="$store.state.pageIs">
        <div ref="seat"></div>
        <router-view id="View"></router-view>
      </div>
    </div>
  </div>
</template>
  
<script>
import ShopHeader from "./header";
import SellerAside from "./aside";
import AsideSwith from "./aside-swith";

let NODE_ENV = process.env.NODE_ENV;
if (NODE_ENV == 'production') {
  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?ffba39766210368416174c70a19d5592";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

export default {
  name: "layout",
  components: {
    ShopHeader,
    SellerAside,
    AsideSwith,
  },
  data() {
    return {
      menuCanOpen: true,
      path: [],
    };
  },
  watch: {
    $route: "getPath",
  },
  mounted() {
    // console.log(1111,document.getElementById('Main').clientWidth)
    this.path = this.$route.path.slice(1).split("/");
    // console.log('Layout:',this.$route.name);
    // this.adaptWinth(this.$route.name);
  },
  methods: {
    // adaptWinth(name){
    //   let main = document.getElementById("Main");
    //   if(name == 'orders'){
    //     main.classList.add("orders");
    //   }
    //   else if(name == 'commodity-Offer'){
    //     main.classList.add("Offer");
    //   }else{
    //     main.classList.remove("orders");
    //     main.classList.remove("Offer");
    //   }
    // },
    getPath() {
      this.path = this.$route.path.slice(1).split("/");
    },
  },
};
</script>

<style scoped>
/* .Offer{
  min-width: 1135px;
}
.orders{
  min-width: 1021px;
} */
/* .Header {
  overflow: auto;
} */
.shop_header {
  position: fixed;
  width: 100%;
  background: #fff;
}

.seller_aside {
  position: fixed;
  width: 100%;
  background: #fff;
  z-index: 1;
  top: 70px;
}

.router_view {
  position: relative;
  left: 240px;
}

#Main {
  /* overflow: auto; */
  /* padding: 0 0 60px 0; */
}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue